/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import SectionService from "../../service/section-service";
import PermissionService from "../../service/permission-service";
import RoleService from "../../service/role-service";
 
const sectionService = new SectionService();
const permissionService = new PermissionService();
const roleService = new RoleService();

await loadDictionary('role-permission-window');

function RolePermissionsWindow({isOpenWindow, onCloseWindow, roleId}) {
  const [role, setRole] = useState(null);
  const [sections, setSections] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const handleClose = () => {
    setRole(null);
    setSections([]);
    setPermissions([]);

    onCloseWindow();
  };
  
  const sync = () => {
    permissionService.syncPermissionsByRoleId(permissions, role.id).then(() => {
      handleClose();
    }).catch(error => {
      console.error(error);
    });
  };

  const updatePermissions = (section) => {
    const hasPermission = permissions.some((permission) => permission.section_id == section.id);

    if(hasPermission) {
      setPermissions(permissions.filter(item => item.section_id !== section.id));
    } else {
      const permission = {
        "id": null,
        "section_id": section.id,
        "role_id": role.id,
        "user_id":null
      };

      setPermissions([...permissions, permission]);
    }
  };

  useEffect(() => {
    if(!isOpenWindow || !roleId) return;

    Promise.all([roleService.findOne(roleId), sectionService.findAll(), permissionService.findAllByRoleId(roleId)])
      .then(([role, sections, permissions]) => {
        setRole(role);
        setSections(sections);
        setPermissions(permissions);
      });
  }, [isOpenWindow, roleId]);

  const sectionItems = sections.map((section) => {
      const isChecked = permissions.some((permission) => permission.section_id == section.id);

      return (
        <Form.Group className="mb-1 col-12" controlId="" key={section.name}>
          <Form.Check type="checkbox" value={section.id} checked={isChecked} onChange={() => {updatePermissions(section)}} label={section.caption}/>
        </Form.Group>
      );
  });

  return (
    <Form method="POST" id="PermissionForm" onSubmit={e => {e.preventDefault(); sync()}}>
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false} scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("role-permission-window.title")}</Modal.Title>
      </Modal.Header>
      <div className="position-relative p-3 pb-1">
        <div className="row">
          <Form.Group className="mb-3 col" controlId="">
            <Form.Label>{i18n.t("role-permission-window.role_name")}</Form.Label>
            <Form.Control type="text" value={role?.name || ''} readOnly></Form.Control>
          </Form.Group>
        </div>
        <div className="row">
          <Form.Group className="col" controlId="">
            <Form.Label>{i18n.t("role-permission-window.section_list")}</Form.Label>
          </Form.Group>
        </div>
      </div>
      <Modal.Body className="pt-1">
        <div className="row">{sectionItems}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("role-permission-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="PermissionForm" >{i18n.t("role-permission-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
    </Form>
  );
}

export default RolePermissionsWindow;